module.exports = __webpack_public_path__ + "img/model_50_ug.f248f74b.jpg";